import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Onderneming } from '../../models/Onderneming';
import { Cash4Bike } from '../../models/Cash4Bike';

import { Resultaat } from '../../models/ResultaatCash4';
import { IFormBuilder, IFormGroup } from '@rxweb/types';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { OndernemingService } from '../../services/onderneming.service';
import { Cash4BikeService } from '../../services/cash4-bike.service';
import { DataService } from '../../services/data.service';
import { mergeMap, catchError, takeUntil } from 'rxjs/operators';
import { throwError, Subject } from 'rxjs';

interface cash4BikeForm {
  maandelijkseLeasePrijs: number | 0.00;
  risicoBuffer: number | 0.00;
  administratiekost: number | 0.00;
  variaBedrag: number | 0.00;
  GroepsverzekeringPercentage: number | 0.00;
  patronaleRSZ: number | 0.00;
  aoPercentage:number | 0.00;
}

@Component({
  selector: 'app-cash4-bike',
  templateUrl: './cash4-bike.component.html',
  styleUrls: ['./cash4-bike.component.scss']
})
export class Cash4BikeComponent implements OnInit {
 //Boolean voor het vertonen van de uitkomst
 calculate = false;

 ondernemingNaam: string;
 onderneming: Onderneming;
 cash4Bike: Cash4Bike;
 resultaat: Resultaat ={
  jaarlijkseLeasekost: 0,
  totaleKostWerkgever: 0,
  brutoloonPerMaand: 0,
  brutoPerJaar: 0,
  patronaleRSZ: 0,
  arbeidsongevallenverzekering: 0,
  groepsverzekering: 0,
  totaal: 0
 }

 componentDestoryed$: Subject<boolean> = new Subject();

    //form variabelen
    formBuilder: IFormBuilder;
    cash4BikeFormGroup: IFormGroup<cash4BikeForm>;
  
    constructor(
      private route: ActivatedRoute,
      formBuilder: FormBuilder,
      private ondernemingService: OndernemingService,
      private cash4BikeService: Cash4BikeService,
      private cd: ChangeDetectorRef,
      public dataService: DataService,
    ) { this.formBuilder = formBuilder }

  ngOnInit(): void {

    this.cash4BikeFormGroup = this.formBuilder.group<cash4BikeForm>({
      maandelijkseLeasePrijs: this.formBuilder.control(null, [Validators.required, Validators.min(0)]),
      risicoBuffer: this.formBuilder.control(0.00, [Validators.min(0)]),
      administratiekost: this.formBuilder.control(0.00, [Validators.min(0)]),
      variaBedrag: this.formBuilder.control(0.00, [Validators.min(0)]),

      //standard values needed?
      GroepsverzekeringPercentage: this.formBuilder.control(2.00, [Validators.min(0)]),
      patronaleRSZ: this.formBuilder.control(35.00, [Validators.min(0)]),
      //standard values needed?
      aoPercentage: this.formBuilder.control(1.19, [Validators.min(0)]),
    });

    this.loadData();
  }
  
   // //validation na het inladen
   ngAfterContentChecked() {
    this.cd.detectChanges();
 }
 

  
  loadData() {
    this.onderneming = this.dataService.getOnderneming();
    this.getCash4Bike(this.onderneming.cash4Bike);
  }

  getCash4Bike(id:string)
  {
    if (this.dataService.cash4Bike== undefined) {
      this.cash4BikeService.getCash4Bike(id).pipe(
        takeUntil(this.componentDestoryed$))
        .subscribe(e => {
          this.cash4Bike = e;
          this.cd.markForCheck();
        });

    }
    else {
      this.cash4Bike = this.dataService.cash4Bike;
    }
  }
   onSubmit() {
     this.calculate = true;
     this.calculateCash();

  }
  //berkenen van de cash4Bike aan de hand van de ingegeven parameters.
  calculateCash()
  {
    this.resultaat.jaarlijkseLeasekost = this.cash4BikeFormGroup.value.maandelijkseLeasePrijs * 12;
    this.resultaat.totaleKostWerkgever = (this.cash4BikeFormGroup.value.maandelijkseLeasePrijs * 12) + this.cash4BikeFormGroup.value.risicoBuffer + this.cash4BikeFormGroup.value.administratiekost + this.cash4BikeFormGroup.value.variaBedrag;
    this.resultaat.brutoloonPerMaand = 
    ((((this.cash4BikeFormGroup.value.maandelijkseLeasePrijs 
      + this.cash4BikeFormGroup.value.risicoBuffer / 12 
      + this.cash4BikeFormGroup.value.administratiekost/12 
      + this.cash4BikeFormGroup.value.variaBedrag / 12)

      / (100 + this.cash4BikeFormGroup.value.GroepsverzekeringPercentage 
        + this.cash4BikeFormGroup.value.patronaleRSZ 
        + this.cash4BikeFormGroup.value.aoPercentage))*100)*12) / 13.92;

    this.resultaat.brutoPerJaar = this.resultaat.brutoloonPerMaand * 13.92;
    this.resultaat.patronaleRSZ = this.resultaat.brutoPerJaar * (this.cash4BikeFormGroup.value.patronaleRSZ / 100);
    this.resultaat.arbeidsongevallenverzekering = this.resultaat.brutoPerJaar * (this.cash4BikeFormGroup.value.aoPercentage / 100);
    this.resultaat.groepsverzekering = this.resultaat.brutoPerJaar * (this.cash4BikeFormGroup.value.GroepsverzekeringPercentage / 100);
    this.resultaat.totaal = this.resultaat.brutoPerJaar + this.resultaat.patronaleRSZ + this.resultaat.arbeidsongevallenverzekering + this.resultaat.groepsverzekering;

  }

  //Auto unsub
  ngOnDestroy() {
    this.componentDestoryed$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.componentDestoryed$.unsubscribe();
  }

}
